import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteRegion = async (id: number) => {
	const response = await cmsClient.delete(
		`/homepage/admin/store/region/${id}/`
	);

	return response.data;
};

const useDeleteRegion = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Region deleted" />, {
			hideProgressBar: true
		});
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-regions"]);
	};

	return useMutation(deleteRegion, { onSuccess, onError, onSettled });
};

export default useDeleteRegion;
